import React from 'react';
import { FormattedMessage } from 'react-intl';
import {getRefusalPdfParagraphs} from "../../../utils/BioBankUtil";

const PrefilledValue = ({ messageId, value }) => (
  <div style={{ overflow: 'auto', marginBottom: '10px' }}>
    <div style={{ width: '200px', float: 'left', marginRight: '5px' }}>
      <span style={{ float: 'right' }}>
        <FormattedMessage id={messageId} />
      </span>
    </div>
    <div style={{ float: 'left', width: '65%' }}>
      <span className={'fill-line'}>{value}</span>
    </div>
  </div>
);

const getCorrectRefusalParagraphs = (version, contentText) => {
  if (contentText.includes("<p>")) {
    const refusalParagraphs = getRefusalPdfParagraphs(contentText);
    return (
      <>
        { refusalParagraphs.map((paragraph, index) => {
          return (
            <>
              {paragraph}
              {index < refusalParagraphs.length - 1 &&
                  <>
                    <br />
                    <br />
                  </>
              }
            </>
          )
        })}
      </>
    )
  } else {
    return (
        <>{contentText}</>
    )
  }
}

export const Refusal = ({
  hetu,
  headerText,
  contentText,
  wholeName,
  address,
  date,
  version
}) => {


  return (
      <div id={'biopankkiPrintContainer'}>
        <div className={'refusal printContent'}>
          <h1 className={'refusal-header'}>{headerText}</h1>
          <br />
          {getCorrectRefusalParagraphs(version, contentText)}
          <br />
          <div style={{ marginTop: '20px' }}>
            <b>
              <FormattedMessage id="biobank.refusal.form.refusal.giver.information" />
            </b>

            <br />
            <div style={{ marginLeft: '100px' }}>
              <PrefilledValue
                  messageId="biobank.refusal.form.refusal.givers.name"
                  value={wholeName}
              />

              <PrefilledValue
                  messageId="biobank.refusal.form.social.security.number"
                  value={hetu}
              />

              <PrefilledValue
                  messageId="biobank.refusal.form.address"
                  value={address}
              />
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            <b>
              <FormattedMessage id="biobank.refusal.form.refusal.giver.signature" />
            </b>
            <div style={{ marginLeft: '100px' }}>
              <PrefilledValue
                  messageId="biobank.refusal.form.place.and.date"
                  value={date}
              />

              <PrefilledValue
                  messageId="biobank.refusal.form.signature"
                  value={`Henkilö ${wholeName} on antanut sähköisen allekirjoituksen`}
              />
            </div>
          </div>
        </div>
      </div>
  );
}
